export default [
  {
    header: 'Modules',
    action: 'ROLE_ADMIM_CONSULTAR',
    resource: 'ACL',
  },
  {
    title: 'Administrative',
    icon: 'UserCheckIcon',
    action: 'ROLE_ADMIM_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Pessoa Física',
        route: 'phisicalPesonPage',
        action: 'ROLE_ADMIM_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Pessoa Jurídica',
        route: 'juridicPersonPage',
        action: 'ROLE_ADMIM_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Relatórios',
        route: 'reportPageAdm',
        action: 'ROLE_ADMIM_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },
  {
    title: 'Convênio',
    icon: 'GridIcon',
    action: 'ROLE_CONV_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Convênios',
        route: 'convenio',
        action: 'ROLE_CONV_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },
  {
    title: 'Financial',
    icon: 'DollarSignIcon',
    action: 'ROLE_FINAN_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Contribuições',
        route: 'mensalidades-dashboard',
        action: 'ROLE_FINAN_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Transações',
        route: 'transacoesFinanceiras',
        action: 'ROLE_FINAN_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Contas',
        route: 'contas',
        action: 'ROLE_FINAN_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Integrações',
        route: 'integracoes',
        action: 'ROLE_FINAN_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Parcelamentos',
        icon: 'LayoutIcon',
        children: [
          {
            title: 'Empréstimos',
            route: 'emprestimo',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
          {
            title: 'Negociações',
            route: 'negociacao',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
        ],
      },
      {
        title: 'Arquivos',
        route: 'importPageNeos',
        action: 'ROLE_FINAN_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Relatórios',
        route: 'reportPageFinancial',
        action: 'ROLE_RELATORIO_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Contábil',
        icon: 'BookOpenIcon',
        children: [
          {
            title: 'DRE',
            route: 'contabilDre',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
          {
            title: 'Livro Razão',
            route: 'contabilLivroRazao',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
          {
            title: 'Razão Analítico',
            route: 'contabilRazaoAnalitico',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
          {
            title: 'Razão Hierárquico',
            route: 'contabilRazaoHierarquico',
            action: 'ROLE_FINAN_CONSULTAR',
            resource: 'ACL',
          },
        ],
      },
    ],
  },
  {
    title: 'Atendimento',
    icon: 'ClockIcon',
    action: 'ROLE_ATEND_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Atendimentos',
        route: 'Attendance',
        action: 'ROLE_ATEND_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Agendamentos',
        route: 'agendamento',
        action: 'ROLE_ATEND_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Agendam. em Lote',
        route: 'agendamentoLote',
        action: 'ROLE_ATEND_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Relatórios',
        route: 'reportPageAttendance',
        action: 'ROLE_ATEND_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },
  {
    title: 'Atendimentos',
    icon: 'ClockIcon',
    action: 'ROLE_PROFISSIONAL',
    resource: 'ACL',
    route: 'AttendanceProfissional',
  },
  {
    title: 'Eventos',
    icon: 'CalendarIcon',
    action: 'ROLE_EVENTO_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Eventos',
        route: 'event',
        action: 'ROLE_EVENTO_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Relatórios',
        route: 'reportPageEvent',
        action: 'ROLE_EVENTO_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },
  {
    title: 'Atendimentos Legados',
    icon: 'ClockIcon',
    action: 'ROLE_PROFISSIONAL',
    resource: 'ACL',
    route: 'AttendanceProfissionalLegado',
  },
  {
    title: 'Ordem de Serviço',
    icon: 'FileTextIcon',
    action: 'ROLE_ORD_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Ordem de Serviços',
        route: 'ordemServico',
        action: 'ROLE_ORD_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },

  {
    title: 'Protocolo',
    icon: 'FileIcon',
    action: 'ROLE_PROT_CONSULTAR',
    resource: 'ACL',
    children: [
      {
        title: 'Protocolos',
        route: 'protocol',
        action: 'ROLE_PROT_CONSULTAR',
        resource: 'ACL',
      },
      {
        title: 'Relatórios',
        route: 'reportPageProtocol',
        action: 'ROLE_PROT_CONSULTAR',
        resource: 'ACL',
      },
    ],
  },
  // {
  //   title: 'Relatórios',
  //   icon: 'SendIcon',
  //   action: 'read',
  //   resource: 'ACL',
  //   children: [
  //     {
  //       title: 'Relatorios',
  //       route: 'reportPage',
  //       action: 'ROLE_EVENTO_CONSULTAR',
  //       esource: 'ACL',
  //     },
  //   ],
  // },
]
